module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-MediumItalic-b2565af16c63cab48d6582b638154983.woff";